"use client";
import React from "react";
import { useContactForm } from "../hooks/useContactForm";
import { ChevronRight } from "lucide-react";

const SendUsMessage = () => {
  const { formik, isLoading } = useContactForm();

  const inputFields = [
    { id: "fullname", label: "Full Name", type: "text" },
    { id: "email", label: "Email Address", type: "email" },
    { id: "phone", label: "Phone Number", type: "text" },
    { id: "package", label: "Subject", type: "text" },
  ];

  return (
    <section className="py-10">
      <div className="max-w-4xl">
        <div className="mb-8">
          <h2 className="text-5xl font-black text-gray-900 tracking-tighter mb-4">
            LET&apos;S <span className="text-primary-500">TALK.</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-md">
            Tell us about your travel plans and let&apos;s craft something
            extraordinary together.
          </p>
        </div>

        <form
          onSubmit={formik.handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12"
        >
          {inputFields.map((field) => (
            <div
              key={field.id}
              className="relative group border-b-2 border-gray-200 focus-within:border-primary-500 transition-all duration-300"
            >
              <input
                id={field.id}
                name={field.id}
                type={field.type}
                placeholder=" "
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values[field.id as keyof typeof formik.values]}
                className="peer w-full bg-transparent pt-6 pb-2 text-gray-900 outline-none placeholder-transparent transition-all"
              />
              <label
                htmlFor={field.id}
                className="absolute left-0 top-6 text-gray-400 font-medium transition-all duration-300 pointer-events-none 
                peer-focus:top-0 peer-focus:text-xs peer-focus:text-primary-500 peer-focus:font-bold
                peer-[:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-primary-500"
              >
                {field.label}
              </label>
            </div>
          ))}

          <div className="col-span-full relative group border-b-2 border-gray-200 focus-within:border-primary-500 transition-all duration-300">
            <textarea
              id="message"
              name="message"
              placeholder=" "
              rows={1}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.message}
              className="peer w-full bg-transparent pt-6 pb-2 text-gray-900 outline-none placeholder-transparent transition-all resize-none"
            />
            <label
              htmlFor="message"
              className="absolute left-0 top-6 text-gray-400 font-medium transition-all duration-300 pointer-events-none 
              peer-focus:top-0 peer-focus:text-xs peer-focus:text-primary-500 peer-focus:font-bold
              peer-[:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-primary-500"
            >
              Tell us everything about your plan...
            </label>
          </div>

          <div className="col-span-full">
            <button
              type="submit"
              disabled={isLoading}
              className="group flex items-center gap-6 outline-none"
            >
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gray-900 text-white group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-500 shadow-lg shadow-gray-200">
                <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
              </div>
              <div className="flex flex-col items-start">
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 group-hover:text-primary-500 transition-colors">
                  Ready to go?
                </span>
                <span className="text-2xl font-black text-gray-900 uppercase tracking-tight">
                  {isLoading ? "Sending..." : "Send Request"}
                </span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default SendUsMessage;
